import { PROFILE_TYPES, RECORD_TYPE } from '@/app/data/model_constants';

// Extra host label between the tenant subdomain and `ziggu` (e.g. a review VM index or a
// worktree key `eng-123`). Set via the VITE_HOST_PREFIX env var; empty in production and main dev.
const HOST_PREFIX = import.meta.env.VITE_HOST_PREFIX;

function hostPrefix() {
  return HOST_PREFIX ? `${HOST_PREFIX}.` : '';
}

// Tenant subdomain of the current host, or null on a tenant-less (parent) host.
function hostSubdomain() {
  const parts = window.location.hostname.split('.');
  const has_subdomain = HOST_PREFIX ? parts.length > 3 : parts.length > 2;
  return has_subdomain ? parts[0] : null;
}

function zigguSubdomainURL(subdomain, path = '') {
  // suffix consists of TLD and possibly port (if non-default)
  const suffix = window.location.origin.split('.').pop();
  return `https://${subdomain}.${hostPrefix()}ziggu.${suffix}${path}`;
}

function zigguProfileSubdomain(profile, tenant) {
  let subdomain;
  if (profile.type === PROFILE_TYPES.SUPERVISOR) {
    subdomain = 'supervisor';
  } else if (tenant.attributes.tenantable_type === RECORD_TYPE.PROJECT) {
    ({ subdomain } = tenant.attributes);
  } else if (tenant.attributes.tenantable_type === RECORD_TYPE.CLIENT) {
    ({ subdomain } = tenant.attributes);
  }
  return subdomain;
}

function zigguParentURL(path = '') {
  // suffix consists of TLD and possibly port (if non-default)
  const suffix = window.location.origin.split('.').pop();
  return `https://${hostPrefix()}ziggu.${suffix}${path}`;
}

const ZIGGU_PARENT_URL = zigguParentURL();

const ZIGGU_API_URL = (() => `${window.location.origin}/api`)();

function zigguProfileTenantURL(profile, tenant) {
  const subdomain = zigguProfileSubdomain(profile, tenant);
  return profile.type === PROFILE_TYPES.CUSTOMER || profile.type === PROFILE_TYPES.SUPERVISOR
    ? zigguSubdomainURL(subdomain)
    : zigguParentURL(`/${profile.type.toLowerCase()}/${subdomain}`);
}

export {
  ZIGGU_API_URL,
  ZIGGU_PARENT_URL,
  zigguSubdomainURL,
  zigguParentURL,
  zigguProfileSubdomain,
  zigguProfileTenantURL,
  hostSubdomain,
};
